const translation = {
    
    // NOMBRES DE SERVICIOS
    'servicio_de_chefs_title': 'Chefs por evento',
    'servicio_de_chefs_desc': 'Este modo te permite tener un chef con un menú de tu elección para las personas que elijas inmediatamente.',
    'servicio_de_chefs_bold': '¡Nos encargamos de todo!',
    'chefs_dias_servicio_title': 'Chefs bajo demanda',
    'chefs_dias_servicio_desc': 'Este servicio es perfecto para aquellos que buscan una solución personalizada para eventos o estancias prolongadas.',
    'chefs_ondemand_title': 'Chefs por temporada',
    'chefs_ondemand_desc': 'Contrata a nuestros Chefs cuando los necesites para los días que necesites.',
    'chefs_dias_servicio_note': '* Este es el tipo de servicio que mejor se adapta a los propietarios de villas o cabañas de huéspedes.',
    'ubicacion': 'Ubicación',

    // LANDING
    'folio': 'Folio',
    'estatus': 'Estatus',
    'nombres': 'Nombre completo',
    'email': 'Correo electrónico',
    'personas': 'Personas (Comensales)',
    'total': 'Total',
    'our_services_desc': 'Nuestro equipo de chefs estará encantado de satisfacer tus necesidades culinarias y proporcionarte una experiencia gastronómica excepcional.',
    'stripePagosId': 'ID de pago de Stripe',
    'FullAddress': 'Domicilio completo',
    'comentarios_cliente': 'Comentarios de cliente',
    'our_menu': 'Nuestro menú',

    // NOMBRES DE MENÚ
    'agenda_inicio': 'Agenda de inicio',
    'menu_descripcion': 'Descripción de menú',
    'main_dishes': 'Platos principales',
    'side_dishes': 'Complementos',
    'appetizers': 'Aperitivos',
    'entree': 'Entradas',
    'preparations': 'Preparados',
    'Persons': 'Personas',
    'Next': 'Siguiente',
    'Configure your menus': 'Configura tu menú',
    'Payment': 'Pagar',
    'Purchase summary': 'Resumen de compra',
    'Processing': 'Procesando',
    'Checkout': 'Revisar la compra',
    'Process payment': 'Procesar pago',
    'Select one': 'Selecciona una opción',
    'not_menus_found': '¡Menus no encontrados!',
    'not_menus_found_lead': 'Lo sentimos mucho pero no encontramos menús para trabajar en éste momento. Intenta nuevamente mas tarde.',
    'call_to_action': '¡Reserva ya!',
    'not_content_found': 'Contenido no encontrado',
    'not_content_found_lead': 'Por favor intenta mas tarde...',
    'zona': 'Zona',

    'logout_ask': '¿Seguro que deseas cerrar sesión y salir?',
    'logout_confirmButtonText': 'Finalizar sesión',
    'logout_cancelButtonText': 'Cancelar',
    'logout_title': '¡Hasta pronto!',
    'logout_logout': 'Tu sesión ha sido terminada.',


    // CONTACT LEAD
    'contact_lead': 'Por favor, llena el siguiente formulario para ponerte en contacto con nosotros',

    // ORDER DETAIL
    'Order detail': 'Detalle de orden',

    // MINOR DETAILS
    'telefono_celular': 'Teléfono celular',
    'created': 'Fecha de creación',
    'modified': 'Fecha de última edición',
}

export {translation};
